import { Element } from '@craftjs/core';

import TableCell from './TableCell';

export const createNewCellOnTableDrop = (
  parentId,
  query,
  actions,
  elementProps
) => {
  const parent = query.node(parentId).get();
  const hasChildren = (parent?.data?.nodes?.length ?? 0) > 0;
  if (hasChildren) return;
  const batched = actions.history.merge();
  const cellEl = <Element is={TableCell} canvas elementProps={elementProps} />;

  const tree = query.parseReactElement(cellEl).toNodeTree();
  batched.addNodeTree(tree, parentId);
};
